import React from "react";
import { cn } from "../../lib/utils/utils";

export function Badge({ className, children }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full bg-primary/12 px-3 py-1 text-xs font-semibold text-primary",
        className
      )}
    >
      {children}
    </span>
  );
}
